import styled from "styled-components";

export const Container = styled.div`
  background-color: ${(props) => props.theme.colors.background};
  color: ${(props) => props.theme.colors.text};
  display: flex;
  align-items: center;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 0 30px;
  box-shadow: 1px 0 10px rgb(0 0 0 / 10%);
  position: relative;

  h1 {
    color: ${(props) => props.theme.colors.textbutton};
  }

  @media (max-width: 1024px) {
    flex-direction: column;
    padding: 20px;
  }
`;

export const HeaderLogo = styled.section`
  width: 32%;
  display: flex;
  gap: 12px;
  flex-direction: column;
  color: white;
  font-size: small;
  align-items: center;

  span {
    font-weight: bold;
  }

  img {
    width: 290px;
  }

  @media (max-width: 1200px) {
    img {
      width: 150px;
    }
  }

  @media (max-width: 900px) {
    margin-left: 0;

    div {
      flex-direction: column;
    }
  }
`;

export const MenuHeader = styled.div`
  position: absolute;
  left: 0;

  z-index: 99999;
  background: transparent;
  /* padding: 7px; */
  color: black;
  display: flex;
  gap: 30px;

  button {
    color: #d9d9d9;
    font-size: 32px;
  }

  a {
    cursor: pointer;
    list-style: none;
    text-decoration: none;
    color: black;
    font-size: 20px;
    font-weight: bold;
  }

  @media (max-width: 700px) {
    position: relative;
    top: 0;
    right: 0;

    a {
      color: white;
    }
  }
`;

export const HeaderMenu = styled.section`
  list-style: none;
  display: flex;
  gap: 2.5rem;
  cursor: pointer;
  align-items: center;
  font-weight: bold;

  li:hover {
    color: ${(props) => props.theme.colors.primary};
    cursor: pointer;
    transition: 0.25s;
    border-bottom: 0;
  }

  svg {
    color: #006240;
  }
`;

export const HeaderSubMenu = styled.div`
  display: flex;
  gap: 63px;

  a {
    text-decoration: none;
  }
  h2 {
    cursor: pointer;
    padding: 10px;
    background: #ddd;
    border-radius: 8px;
    color: #4f4f4f;
    font-weight: 500;

    width: 127px;
    text-align: center;
  }
`;
